module.exports = __webpack_public_path__ + "static/logo-nyc-health-5bee1954839beb914a304946ba45c567.png";